import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DgTimerService } from '../dg_components/dg-timer/dg-timer.service';
import { AppInitService } from './app-init.service';

@Injectable({
  providedIn: 'root',
})
// -1: EXPIRED
//  0: IDLE
//  1: START
//  2: PAUSE/STOP
export class SessionCheckerService {
  private sessionCheckerStatus = new BehaviorSubject<number>(0);
  public sessionCheckerStatus$ = this.sessionCheckerStatus.asObservable();
  private sessionRemainingTime = new BehaviorSubject<number>(-1);
  public sessionRemainingTime$ = this.sessionRemainingTime.asObservable();
  subscription: Subscription;

  constructor(
    private appInitService: AppInitService,
    private dgTimerService: DgTimerService
  ) {
    window.addEventListener('storage', (event) => {
      if (event.key == 'param_1') {
        this.refreshCountDown(!localStorage.getItem('param_1'), true);
      }
    });
  }
  startCountDown(): void {
    this.sessionCheckerStatus.next(1);
    this.startObs();
  }
  private startObs(isSessionExpired = false): void {
    let timer = Number(this.appInitService?.appConfig?.setCountDownTime);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    let timeInSeconds = timer * 60 + 1; //added 1 sec bcs Math.floor start value - 1 sec

    if (!isSessionExpired) {
      let timeStored = localStorage.getItem('param_1');
      if (!timeStored) {
        let sessionExpiryTime = new Date();
        sessionExpiryTime.setSeconds(
          sessionExpiryTime.getSeconds() + timeInSeconds
        );
        localStorage.setItem('param_1', sessionExpiryTime.getTime().toString());
      } else {
        let sessionExpiryTime = new Date(Number(timeStored));
        timeInSeconds =
          parseInt(
            Math.floor(
              (sessionExpiryTime.getTime() - new Date().getTime()) / 1000
            ).toString()
          ) + 1; //added 1 sec bcs Math.floor start value - 1 sec
      }
    }

    this.subscription = this.dgTimerService
      .getTimerObs(timeInSeconds, 1, 'sessionTimer')
      .subscribe((timeLeft: number) => {
        this.sessionRemainingTime.next(timeLeft);
      });
  }

  refreshCountDown(isSessionExpired = false, localStorgeChanged = false): void {
    if (!localStorgeChanged) {
      localStorage.removeItem('param_1');
    }
    this.sessionCheckerStatus.next(1);
    this.startObs(isSessionExpired);
  }
  stopCountDown(stauts = 0): void {
    this.sessionRemainingTime.next(-1);
    this.sessionCheckerStatus.next(stauts);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
